import * as React from 'react';
import { StaticQuery } from 'gatsby';
import { EntryGrid } from '../components/entry-grid';
import { EntryCard } from '../components/entry-card';
import { MarkdownBlock } from './markdown-block';
export var CategoryEntries = function CategoryEntries(props) {
  return /*#__PURE__*/React.createElement(StaticQuery, {
    query: "2738022811",
    render: function render(data) {
      var nodes = data.allMdx.nodes.filter(function (node) {
        return node.frontmatter.category === props.category && hasTags(node.frontmatter.tags, props.tags);
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EntryGrid, Object.assign({
        items: nodes,
        compact: !props.spareGrid
      }, props), function (item) {
        var children = props.children,
            asMarkdown = props.asMarkdown;

        if (children) {
          return children(item);
        } else if (asMarkdown) {
          return /*#__PURE__*/React.createElement(MarkdownBlock, {
            className: item.frontmatter.className
          }, item.body);
        } else {
          return /*#__PURE__*/React.createElement(EntryCard, {
            heading: item.frontmatter.title,
            excerpt: item.frontmatter.description || item.excerpt,
            imagePath: item.fields.featuredImage,
            slug: item.fields.slug,
            readMoreLabel: props.readMoreLabel
          });
        }
      }));
    }
  });
};

function hasTags(tags, targetTags) {
  if (!targetTags) return true;
  return tags.filter(function (tag) {
    return targetTags.includes(tag);
  }).length;
}